import apiServerConstants from "./apiServerConstants"
import { fetchFormData, fetchJson, fetchResource, fetchUrlencoded, HTTP_VERB } from "../../lib/utils"

const apiServerApi = {

  saveCustomer: (accessToken, data) => fetchJson(
    HTTP_VERB.POST, 
    `${apiServerConstants.host}/customers`,
    accessToken,
    JSON.stringify(data)
  ),

  removeCustomer: (accessToken, id) => fetchUrlencoded(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/customers`,
    accessToken,
    `customerId=${id}`
  ),

  getLoanImage: (accessToken, url) => fetch(
    url,
    {
      method: "GET",
      headers: {
        Accept: "image/jpeg",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).then(response => response),

  saveBundle: (accessToken, data) => fetchJson(
    HTTP_VERB.POST, 
    `${apiServerConstants.host}/bundle/save`,
    accessToken,
    JSON.stringify(data)
  ),

  removeBundle: (accessToken, id) => {

    const data = new FormData()
    data.append("bundleId", id)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/bundle/delete`,
      accessToken,
      data
    )
  },

  saveBundleImage: (accessToken, file, id) => {

    const data = new FormData()
    data.append("file", file)
    if(id !== undefined) {
      data.append("bundleId", id)
    }

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/bundle/image/upload`,
      accessToken,
      data
    )
  },

  getLoanById: (accessToken, loanId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loans/${loanId}`,
    accessToken,
    null
  ),

  removeLoan: (accessToken, id) => fetchUrlencoded(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/delete`,
    accessToken,
    `bundleId=${id}`
  ),

  getAllBatches: (accessToken, page, size) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/batches?page=${page}&size=${size}`,
    accessToken,
    null
  ),

  importBatchesFromCSV: (accessToken, data) => {

    const formData = new FormData()
    formData.append("csv_file", data, "csv_file")

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/import/batch`,
      accessToken,
      formData
    )
  },

  uploadUpdate: (accessToken, inputId) => {

    const input = document.getElementById(inputId),
    requestData = new FormData()
    requestData.append("file", input.files[0])

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/updates/upload`,
      accessToken,
      requestData
    )
  },

  getAllUpdates: accessToken => fetchJson(
    HTTP_VERB.GET, 
    `${apiServerConstants.host}/updates`,
    accessToken,
    null
  ),

  countLoansForUser: (accessToken, username) => fetchJson(
    HTTP_VERB.GET, 
    `${apiServerConstants.host}/loans/countLoanAssignToUser?username=${username}`,
    accessToken,
    null
  ),

  changeLoanAssignee: (accessToken, fromUsername, toUsername) => fetchJson(
    HTTP_VERB.GET, 
    `${apiServerConstants.host}/loans/changeAssignee?fromUsername=${fromUsername}&toUsername=${toUsername}`,
    accessToken,
    null
  ),

  countBundleLoans: (accessToken, bundleId) => fetchJson(
    HTTP_VERB.GET, 
    `${apiServerConstants.host}/bundle/${bundleId}/countloans`,
    accessToken,
    null
  ),

  changeBundleStatus: (accessToken, bundleId, status) => fetchJson(
    HTTP_VERB.POST, 
    `${apiServerConstants.host}/bundle/${bundleId}/changestatus?active=${status}`,
    accessToken,
    null
  ),

  makeRepayment: (accessToken, loanId, data) => fetchJson(
    HTTP_VERB.POST, 
    `${apiServerConstants.host}/loans/${loanId}/makerepayment`,
    accessToken,
    JSON.stringify(data)
  ),

  organizationIconURL: organizationId =>
    `${apiServerConstants.host}/organizations/${organizationId}/downloadicon`,

  getOrganizations: (accessToken, page, size) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/organizations?page=${page}&size=${size}`,
    accessToken,
    null
  ),

  getOrganizationById: (accessToken, organizationId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/organizations/${organizationId}`,
    accessToken,
    null
  ),

  saveOrganization: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/organizations`,
    accessToken,
    JSON.stringify(data)
  ),

  updateOrganization: (accessToken, organizationId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/organizations/${organizationId}`,
    accessToken,
    JSON.stringify(data)
  ),

  saveOrganizationIcon: (accessToken, organizationId, icon) => {

    const data = new FormData()
    data.append("icon", icon)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/organizations/${organizationId}/icon`,
      accessToken,
      data
    )
  },

  changeOrganizationStatus: (accessToken, organizationId, status) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/organizations/${organizationId}/changestatus?active=${status}`,
    accessToken,
    null
  ),

  getLastTAndC: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/tandc/last`,
    accessToken,
    null
  ),

  getDefaultTAndC: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/tandc/default`,
    accessToken,
    null
  ),

  saveTAndC: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/tandc`,
    accessToken,
    JSON.stringify(data)
  ),

  updateTransaction: (accessToken, loanId, transactionId, transactionDate, transactionAmount) => {

    const data = new FormData()
    data.append("transactionDate", transactionDate)
    data.append("transactionAmount", transactionAmount)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/loans/${loanId}/transactions/${transactionId}`,
      accessToken,
      data
    )
  },

  getTransactionByFineractId: (accessToken, fineractId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/repayments/getbyfineractid/${fineractId}`,
    accessToken,
    null
  ),

  setLoanVerificationType: (accessToken, type) => {

    const data = new FormData()
    data.append("loanVerificationType", type)

    return fetchFormData(
      HTTP_VERB.PUT,
      `${apiServerConstants.host}/loans/setloanverificationtype`,
      accessToken,
      data
    )
  },

  triggerLoanRecording: (accessToken, loanId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/triggerrecording`,
    accessToken,
    null
  ),

  getCustomerConfig: accessToken =>
    fetchJson(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/organizations/customerconfig`,
      accessToken,
      null
    ),

  saveCustomerInfo: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/organizations/customerinfo`,
    accessToken,
    JSON.stringify(data)
  ),

  saveCustomerDocuments: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/organizations/customerdocuments`,
    accessToken,
    JSON.stringify(data)
  ),

  fixAdminCreation: (accessToken, organizationId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/organizations/fixadmincreation/${organizationId}`,
    accessToken,
    null
  ),

  getOfflineQRCode: (accessToken, sessionId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/commander/offlinedeviceqrcode?${sessionId ? 'sessionId=' + sessionId : ''}`,
    accessToken,
    null
  ),

  deleteQRHistorical: accessToken => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/deleteqrhistorical`,
    accessToken,
    null
  ),

  getActiveLoanReport: (accessToken, officeId, reportType, outputType, loanProductId) => {

    const params = `officeId=${officeId}&reportType=${reportType}&loanProductId=${loanProductId}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/loans/active?${params}`,
      accessToken,
      null
    )
  },

  getExpectedPaymentByDateReport: (accessToken, officeId, groupId, startDate, endDate, outputType) => {

    const params = `officeId=${officeId}&startDate=${startDate}&endDate=${endDate}&outputType=${outputType}`,
      uri = Number(groupId) > 0
      ? `expectedpaymentbydateandaffiliation?groupId=${groupId}&${params}` 
      : `expectedpaymentbydate?${params}`

    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/${uri}`,
      accessToken,
      null
    )
  },

  getBalanceOutstandingReport: (accessToken, officeId, onDate, outputType) => {

    const params = `officeId=${officeId}&onDate=${onDate}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/balanceoutstanding?${params}`,
      accessToken,
      null
    )
  },

  getAgingLoanReport: (accessToken, officeId, outputType) => {

    const params = `officeId=${officeId}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/agingdetail?${params}`,
      accessToken,
      null
    )
  },

  getPortfolioAtRiskReport: (accessToken, officeId, loanProductId, outputType) => {

    const params = `officeId=${officeId}&loanProductId=${loanProductId}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/portfolioatrisk?${params}`,
      accessToken,
      null
    )
  },

  getBranchCashIn: (accessToken, officeId, fromDate, toDate, reportType, outputType) => {

    const params = `officeId=${officeId}&fromDate=${fromDate}&toDate=${toDate}&reportType=${reportType}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/branchcashin?${params}`,
      accessToken,
      null
    )
  },

  getLoanGenerality: (accessToken, officeId, startDate, endDate, type, outputType) => {

    const params = `officeId=${officeId}&startDate=${startDate}&endDate=${endDate}&type=${type}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/loansgenerality?${params}`,
      accessToken,
      null
    )
  },

  getLoansDisbursedByAffiliation: (accessToken, officeId, groupId, startDate, endDate, outputType) => {

    const params = `officeId=${officeId}&groupId=${groupId}&startDate=${startDate}&endDate=${endDate}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/loansdisbursedbyaffiliation?${params}`,
      accessToken,
      null
    )
  },

  getBatchPerformance: (accessToken, officeId, groupId, batchId, startDate, endDate, reportType, outputType) => {

    const params = `officeId=${officeId}&groupId=${groupId}&batchId=${batchId}&startDate=${startDate}&endDate=${endDate}&reportType=${reportType}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/batchperformance?${params}`,
      accessToken,
      null
    )
  },

  getBucketPerformance: (accessToken, officeId, bucketId, startDate, endDate, reportType, outputType) => {

    const params = `officeId=${officeId}&bucketId=${bucketId}&startDate=${startDate}&endDate=${endDate}&reportType=${reportType}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/bucketperformance?${params}`,
      accessToken,
      null
    )
  },

  getDefaultedLoansDetails: (accessToken, officeId, groupId, startDate, endDate, outputType) => {

    const params = `officeId=${officeId}&groupId=${groupId}&startDate=${startDate}&endDate=${endDate}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/defaultedloansdetails?${params}`,
      accessToken,
      null
    )
  },

  /////////////////////////////////////////////////////////

  checkUpfrontPayment: (accessToken, loanId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loans/${loanId}/checkupfrontpayment`,
    accessToken,
    null
  ),

  openDevice: (accessToken, loanId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/opendevice`,
    accessToken,
    null
  ),

  retrieveLoanDetails: (accessToken, loanId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loans/${loanId}/retrievedetails`,
    accessToken,
    null
  ),

  triggerBundleRecording: (accessToken, bundleId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/bundle/${bundleId}/triggerrecording`,
    accessToken,
    null
  ),

  resumeLoanRecording: (accessToken, loanId, step) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/resumeloanrecording?step=${step}`,
    accessToken,
    null
  ),

  parseCsvMomo: (accessToken, data) => {

    const formData = new FormData()
    formData.append("csvFile", data, "csvFile")

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/loans/parsecsvmomo`,
      accessToken,
      formData
    )
  },
  
  batchRepayment: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/batchrepayment`,
    accessToken,
    JSON.stringify(data)
  ),

  affiliateCustomer: (accessToken, customerId, businessId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/customers/${customerId}/affiliate${businessId ? `?businessId=${businessId}` : ''}`,
    accessToken,
    null
  ),

  saveBusiness: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/business?isloan=false`,
    accessToken,
    JSON.stringify(data)
  ),

  updateBusiness: (accessToken, businessId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/business/${businessId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deviceStatus: (accessToken, imei) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/devicestatus/${imei}`,
    accessToken,
    null
  ),

  deviceOperation: (accessToken, imei, type) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/deviceoperation/${imei}?type=${type}`,
    accessToken,
    null
  ),

  changeSIM: (accessToken, imei, phoneNumber) => {

    const formData = new FormData()
    formData.append("phoneNumber", phoneNumber)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/commander/changesim/${imei}`,
      accessToken,
      formData
    )
  },

  retryRegisterDevice: (accessToken, imei) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/registerdevice/${imei}`,
    accessToken,
    null
  ),

  deleteLoan: (accessToken, loanId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/loans/${loanId}/delete`,
    accessToken,
    null
  ),

  updateLoanBundle: (accessToken, loanId, bundleId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/updatebundle/${bundleId}`,
    accessToken,
    null
  ),

  updateUserData: (accessToken, username) => {

    const data = new FormData()
    data.append("username", username)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/loans/updateuserdata`,
      accessToken,
      data
    )
  },

  acceptedImei: (accessToken, imei) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/commander/acceptedimei/${imei}`,
    accessToken,
    null
  ),

  offlineAuthQr: (accessToken, imei) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/commander/offlineauthqr/${imei}`,
    accessToken,
    null
  ),

  extendUsage: (accessToken, imei, timestamp) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/extendusage/${imei}?timestamp=${timestamp}`,
    accessToken,
    null
  ),

  createLoanCharge: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loancharge`,
    accessToken,
    JSON.stringify(data)
  ),

  getLoanCharge: (accessToken, chargeId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loancharge/${chargeId}`,
    accessToken,
    null
  ),

  updateLoanCharge: (accessToken, chargeId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/loancharge/${chargeId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteLoanCharge: (accessToken, chargeId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/loancharge/${chargeId}`,
    accessToken,
    null
  ),

  triggerChargeRecording: (accessToken, chargeId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loancharge/${chargeId}/triggerrecording`,
    accessToken,
    null
  ),

  createGLAccount: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/glaccounts`,
    accessToken,
    JSON.stringify(data)
  ),

  getGLAccount: (accessToken, glaccountId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/glaccounts/${glaccountId}`,
    accessToken,
    null
  ),

  updateGLAccount: (accessToken, glaccountId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/glaccounts/${glaccountId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteGLAccount: (accessToken, glaccountId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/glaccounts/${glaccountId}`,
    accessToken,
    null
  ),

  triggerGLAccountRecording: (accessToken, glaccountId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/glaccounts/${glaccountId}/triggerrecording`,
    accessToken,
    null
  ),

  createGLClosure: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/glclosures`,
    accessToken,
    JSON.stringify(data)
  ),

  getGLClosure: (accessToken, glclosureId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/glclosures/${glclosureId}`,
    accessToken,
    null
  ),

  updateGLClosure: (accessToken, glclosureId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/glclosures/${glclosureId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteGLClosure: (accessToken, glclosureId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/glclosures/${glclosureId}`,
    accessToken,
    null
  ),

  triggerGLClosureRecording: (accessToken, glclosureId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/glclosures/${glclosureId}/triggerrecording`,
    accessToken,
    null
  ),

  getLastClosingDate: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/glclosures/lastclosingdate`,
    accessToken,
    null
  ),

  loadJournalEntryByTransactionId: (accessToken, transactionId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/journalentries/list`,
    accessToken,
    JSON.stringify({ transactionId })
  ),

  getJournalEntry: (accessToken, journalentryId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/journalentries/${journalentryId}`,
    accessToken,
    null
  ),

  createJournalEntry: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/journalentries`,
    accessToken,
    JSON.stringify(data)
  ),

  updateRunningBalance: (accessToken) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/journalentries/updaterunningbalance`,
    accessToken,
    null
  ),

  reverseJournalEntry: (accessToken, transactionId, transactionDate, comments) => {

    const data = new FormData()
    data.append('transactionDate', transactionDate)
    data.append("comments", comments)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/journalentries/${transactionId}/reverse`,
      accessToken,
      data
    )
  },

  triggerJournalEntryRecording: (accessToken, journalEntryId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/journalentries/${journalEntryId}/triggerrecording`,
    accessToken,
    null
  ),
  
  createAccountingRule: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/accountingrules`,
    accessToken,
    JSON.stringify(data)
  ),

  getAccountingRule: (accessToken, accountingruleId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/accountingrules/${accountingruleId}`,
    accessToken,
    null
  ),

  updateAccountingRule: (accessToken, accountingruleId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/accountingrules/${accountingruleId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteAccountingRule: (accessToken, accountingruleId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/accountingrules/${accountingruleId}`,
    accessToken,
    null
  ),

  triggerAccountingRuleRecording: (accessToken, accountingruleId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/accountingrules/${accountingruleId}/triggerrecording`,
    accessToken,
    null
  ),

  getGeneralLedgerReport: (accessToken, officeId, startDate, endDate, glAccountId, outputType) => {

    const params = `officeId=${officeId}&startDate=${startDate}&endDate=${endDate}&glAccountId=${glAccountId}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/generalledgerreport?${params}`,
      accessToken,
      null
    )
  },

  getIncomeStatement: (accessToken, officeId, startDate, endDate, outputType) => {

    const params = `officeId=${officeId}&startDate=${startDate}&endDate=${endDate}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/incomestatement?${params}`,
      accessToken,
      null
    )
  },

  getBalanceSheet: (accessToken, officeId, endDate, outputType) => {

    const params = `officeId=${officeId}&endDate=${endDate}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/balancesheet?${params}`,
      accessToken,
      null
    )
  },

  getTrialBalance: (accessToken, officeId, startDate, endDate, outputType) => {

    const params = `officeId=${officeId}&startDate=${startDate}&endDate=${endDate}&outputType=${outputType}`
    return fetchResource(
      HTTP_VERB.GET,
      `${apiServerConstants.host}/reports/trialbalance?${params}`,
      accessToken,
      null
    )
  },

  getLoanCommission: (accessToken, loanCommissionId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loancommissions/${loanCommissionId}`,
    accessToken,
    null
  ),

  createLoanCommission: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loancommissions`,
    accessToken,
    JSON.stringify(data)
  ),

  updateLoanCommission: (accessToken, loanCommissionId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/loancommissions/${loanCommissionId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteLoanCommission: (accessToken, loanCommissionId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/loancommissions/${loanCommissionId}`,
    accessToken,
    null
  ),

  loadCommissionLogs: (accessToken, page, size) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/commissionlogs?page=${page}&size=${size}`,
    accessToken,
    null
  ),

  deleteCommissionLog: (accessToken, commissionLogId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/commissionlogs/${commissionLogId}`,
    accessToken,
    null
  ),

  deleteAllCommissionLog: accessToken => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/commissionlogs/deleteall`,
    accessToken,
    null
  ),

  updateDefaultCurrency: (accessToken, currency) => {

    const data = new FormData()
    data.append("currency", currency)

    return fetchFormData(
      HTTP_VERB.POST,
      `${apiServerConstants.host}/organizations/updatedefaultcurrency`,
      accessToken,
      data
    )
  },

  getCurrencyRates: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/currencyrates`,
    accessToken,
    null
  ),

  saveCurrencyRate: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/currencyrates`,
    accessToken,
    JSON.stringify(data)
  ),

  getLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loanaccountingrules`,
    accessToken,
    null
  ),

  saveLoanAccountingRule: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loanaccountingrules`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/loanaccountingrules`,
    accessToken,
    null
  ),

  olderTransactions: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/loanaccountingrules/oldertransactions`,
    accessToken,
    null
  ),

  manageOlderTransactions: accessToken => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loanaccountingrules/manageoldertransactions`,
    accessToken,
    null
  ),

  getExtraLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/extraloanaccountingrule`,
    accessToken,
    null
  ),

  saveExtraLoanAccountingRule: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/extraloanaccountingrule`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteExtraLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/extraloanaccountingrule`,
    accessToken,
    null
  ),

  updateLoanBundlepurchasecost: (accessToken, loanId, purchaseCost) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/updatepurchasecost?purchaseCost=${purchaseCost}`,
    accessToken,
    null
  ),

  updateLoanBundleCommissions: (accessToken, loanId, commissions) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/updatecommissions`,
    accessToken,
    JSON.stringify(commissions)
  ),

  getCustomLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/customloanaccountingrule`,
    accessToken,
    null
  ),

  saveCustomLoanAccountingRule: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/customloanaccountingrule`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteCustomLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/customloanaccountingrule`,
    accessToken,
    null
  ),

  filterFullyRepaidLoans: (accessToken, loanIds) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/filterfullyrepaidloans`,
    accessToken,
    JSON.stringify(loanIds)
  ),

  loanSummaries: (accessToken, loanIds) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/commander/loansummaries`,
    accessToken,
    JSON.stringify(loanIds)
  ),

  ///////////////////////// Batch

  createFinancierBatch: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbatch`,
    accessToken,
    JSON.stringify(data)
  ),

  getFinancierBatch: (accessToken, batchId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/financierbatch/${batchId}`,
    accessToken,
    null
  ),

  updateFinancierBatch: (accessToken, batchId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/financierbatch/${batchId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteFinancierBatch: (accessToken, batchId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/financierbatch/${batchId}`,
    accessToken,
    null
  ),

  changeStatusFinancierBatch: (accessToken, batchId, isClosed) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbatch/${batchId}/${isClosed ? 'close' : 'open'}`,
    accessToken,
    null
  ),

  addLoanFinancierBatch: (accessToken, batchId, loanId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbatch/${batchId}/addloan?loanId=${loanId}`,
    accessToken,
    null
  ),

  removeLoanFinancierBatch: (accessToken, batchId, loanId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbatch/${batchId}/removeloan?loanId=${loanId}`,
    accessToken,
    null
  ),

  ////////////////////////// Bucket

  createFinancierbucket: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbucket`,
    accessToken,
    JSON.stringify(data)
  ),

  getFinancierbucket: (accessToken, bucketId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/financierbucket/${bucketId}`,
    accessToken,
    null
  ),

  updateFinancierbucket: (accessToken, bucketId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/financierbucket/${bucketId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteFinancierbucket: (accessToken, bucketId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/financierbucket/${bucketId}`,
    accessToken,
    null
  ),

  changeStatusFinancierBucket: (accessToken, bucketId, isClosed) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbucket/${bucketId}/${isClosed ? 'close' : 'open'}`,
    accessToken,
    null
  ),

  addMoneyFinancierFucket: (accessToken, bucketId, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbucket/${bucketId}/addmoney`,
    accessToken,
    JSON.stringify(data)
  ),

  removeMoneyFinancierFucket: (accessToken, bucketId, depositId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbucket/${bucketId}/removemoney?depositId=${depositId}`,
    accessToken,
    null
  ),

  addBatchFinancierBucket: (accessToken, bucketId, batchId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbucket/${bucketId}/addbatch?batchId=${batchId}`,
    accessToken,
    null
  ),

  removeBatchFinancierBucket: (accessToken, bucketId, batchId) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/financierbucket/${bucketId}/removebatch?batchId=${batchId}`,
    accessToken,
    null
  ),

  ///////////////////////////////////////////////////////

  getInvestor: (accessToken, investorId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/investors/${investorId}`,
    accessToken,
    null
  ),

  saveInvestor: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/investors`,
    accessToken,
    JSON.stringify(data)
  ),

  updateInvestor: (accessToken, investorId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/investors/${investorId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteInvestor: (accessToken, investorId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/investors/${investorId}`,
    accessToken,
    null
  ),

  ////////////////////////////// Investors ///////////////////////////////

  getInvestorPayment: (accessToken, paymentId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/investorpayment/${paymentId}`,
    accessToken,
    null
  ),

  getPaymentByInvestor: (accessToken, investorId) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/investorpayment/getbyinvestor/${investorId}`,
    accessToken,
    null
  ),

  saveInvestorPayment: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/investorpayment`,
    accessToken,
    JSON.stringify(data)
  ),

  updateInvestorPayment: (accessToken, paymentId, data) => fetchJson(
    HTTP_VERB.PUT,
    `${apiServerConstants.host}/investorpayment/${paymentId}`,
    accessToken,
    JSON.stringify(data)
  ),

  deleteInvestorPayment: (accessToken, paymentId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/investorpayment/${paymentId}`,
    accessToken,
    null
  ),

  ///////////////////////////// Accounting Setting //////////////////////////////

  getRepaymentAccountType: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/accountingsetting/repaymentaccounttype`,
    accessToken,
    null
  ),

  saveRepaymentAccountType: (accessToken, type) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/accountingsetting/repaymentaccounttype?type=${type}`,
    accessToken,
    null
  ),

  /////////////////////////// Loans ///////////////////////////

  updateLoanGroup: (accessToken, loanId, group) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/loans/${loanId}/updategroup?group=${encodeURIComponent(group)}`,
    accessToken,
    null
  ),

  getDefaultedLoanAccountingRule: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/defaultloanaccountingrule`,
    accessToken,
    null
  ),

  saveDefaultedLoanAccountingRule: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/defaultloanaccountingrule`,
    accessToken,
    JSON.stringify(data)
  ),

  getVATAccountingRule: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/vataccountingrule`,
    accessToken,
    null
  ),

  saveVATAccountingRule: (accessToken, data) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/vataccountingrule`,
    accessToken,
    JSON.stringify(data)
  ),

  getNotifications: (accessToken, page, size) => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/notifications?page=${page}&size=${size}`,
    accessToken,
    null
  ),

  markAllNotificationsRead: (accessToken, notificationIds = null) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/notifications/readall`,
    accessToken,
    notificationIds ? JSON.stringify(notificationIds) : null
  ),

  deleteAllNotifications: (accessToken, notificationIds = null) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/notifications/deleteall`,
    accessToken,
    notificationIds ? JSON.stringify(notificationIds) : null
  ),

  countUnreadNotifications: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/notifications/unreadcount`,
    accessToken,
    null
  ),
  //------------------------- Download requests

  getDownloadRequests: accessToken => fetchJson(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/reports/requests`,
    accessToken,
    null
  ),

  checkDownloadRequestStatuses: (accessToken, requestIds) => fetchJson(
    HTTP_VERB.POST,
    `${apiServerConstants.host}/reports/requests/getbyids`,
    accessToken,
    JSON.stringify(requestIds)
  ),

  deleteDownloadRequest: (accessToken, requestId) => fetchJson(
    HTTP_VERB.DELETE,
    `${apiServerConstants.host}/reports/requests/${requestId}`,
    accessToken,
    null
  ),

  downloadReportRequest: (accessToken, requestId) => fetchResource(
    HTTP_VERB.GET,
    `${apiServerConstants.host}/reports/${requestId}/download`,
    accessToken,
    null
  ),
}

export default apiServerApi



// WEBPACK FOOTER //
// ./src/redux/sagas/apiServerApi.js